import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  AddButton,
  BackButton,
  ThinDropdown,
  ThinDropdownWithSearch,
  ThinTextField,
} from "../../common/GeneralComponent";
import { fetchData } from "../../../utils/functions";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const validationSchema = Yup.object({
  Name: Yup.string()
    .required("Division name is required")
    .matches(/^[a-zA-Z\s]+$/, "Division Name cannot contain special characters")
    .min(3, "Division Name must be at least 3 characters long")
    .max(50, "Division Name must be at most 50 characters long"),
  Status: Yup.string().required("Status is required"),
  Province_Id: Yup.string().required("Province is required"),
});

const AddDivision = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [generatedCode, setGeneratedCode] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [provinces, setProvinces] = useState([]);

  useEffect(() => {
    const fetchProvinces = async () => {
      try {
        const response = await fetchData(
          "provinces",
          "GET",
          null,
          {},
          {},
          navigate,
          "/provinces",
          dispatch
        );
        setProvinces(response?.data || []);
      } catch (error) {
        toast.error("Failed to load provinces.");
      }
    };
    fetchProvinces();
  }, [dispatch, navigate]);

  const formik = useFormik({
    initialValues: {
      Name: "",
      Status: 1,
      Province_Id: "",
    },
    validationSchema,
    onSubmit: async (values) => {
      try {
        setIsSubmitting(true);
        const response = await fetchData(
          "divisions",
          "POST",
          {
            Name: values.Name,
            Status: values.Status,
            Province_Id: values.Province_Id,
          },
          {},
          {},
          navigate,
          "/divisions",
          dispatch
        );
        toast.success("Division created Successfully");
        navigate("/divisions");
      } catch (error) {
        toast.error(error.message || "Error creating division");
      } finally {
        setIsSubmitting(false);
      }
    },
  });

  const generateCodeFromName = (name) => {
    if (name && name.length >= 2) {
      return name.substring(0, 2).toUpperCase();
    }
    return "";
  };

  return (
    <div className="w-full my-4 mx-auto">
      <div className="flex  lg:flex-row flex-col lg:justify-between justify-start lg:items-center items-start gap-3 w-full">
        <h1 className="lg:text-[1.475rem] text-[1rem] text-[#212529] font-[Bold]">
          Create Division
        </h1>
        <BackButton text="Back" to="/divisions" />
      </div>
      <div className="bg-white rounded-lg shadow w-full lg:mb-[30px] mt-4  mb-[7rem]">
        <div className="p-4 flex md:flex-row rounded-t-lg gradiant2 flex-col gap-3 justify-between md:items-center border-lightGray border-b ">
          <h1 className="lg:text-[0.875rem] text-[13px]  tracking-[0.0625rem] text-[#856800] font-[bold] uppercase">
            Create Division
          </h1>
        </div>
        <form className="p-4" onSubmit={formik.handleSubmit}>
          <div className="grid lg:grid-cols-2 gap-5 grid-cols-1">
            <ThinDropdownWithSearch
              label="Province"
              id="province-dropdown"
              options={provinces.map((province) => ({
                value: province.province_id,
                label: province.province,
              }))}
              value={formik.values.Province_Id}
              onChange={(value) => formik.setFieldValue("Province_Id", value)}
              error={formik.touched.Province_Id && formik.errors.Province_Id}
              helperText={
                formik.touched.Province_Id && formik.errors.Province_Id
              }
              required={true}
            />
            <ThinTextField
              id="Name"
              label="Division Name"
              placeholder="Hyderabad"
              type="text"
              name="Name"
              value={formik.values.Name}
              onChange={(e) => {
                formik.handleChange(e);
                const code = generateCodeFromName(e.target.value);
                setGeneratedCode(code);
              }}
              onBlur={formik.handleBlur}
              error={formik.touched.Name && formik.errors.Name}
              helperText={formik.touched.Name && formik.errors.Name}
            />
            <ThinTextField
              id="divisions_code"
              label="Division Code"
              type="text"
              value={generatedCode}
              onChange={() => {}}
              onBlur={() => {}}
              disabled={true}
              error={false}
              helperText="Code is auto-generated"
            />
            <ThinDropdown
              label="Status"
              id="Status-dropdown"
              name="Status"
              options={[
                { value: 1, label: "Active" },
                { value: 0, label: "In-Active" },
              ]}
              value={formik.values.Status}
              onChange={(e) => formik.setFieldValue("Status", e.target.value)}
              onBlur={formik.handleBlur}
              error={formik.touched.Status && formik.errors.Status}
              helperText={formik.touched.Status && formik.errors.Status}
            />
          </div>
          <div className="p-4">
            <AddButton text="Submit" type="Submit" isLoading={isSubmitting} />
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddDivision;
